import {Collapse} from "bootstrap";
import $ from "jquery";
import {modelSelect, ncSelect} from "./selectFields";
import alertElica from "./alert";

export default function cloneProduct() {
    const itemAdd = document.querySelector('#item-add');
    if (itemAdd) {
        itemAdd.addEventListener('click', () => {
            // Get latest item
            let elem = $('#productsAccordion .accordion-collapse[data-id=' + window.lastProduct + ']').parents('.accordion-item').get(0);

            if (elem.dataset.saved === "true") {
                //non salvo di nuovo apro solo nuovo box
                insertNew();
                return false;
            }

            //save product before clone
            let data = new FormData();
            let inputElements = $(elem).find("input,select,textarea").serializeArray();
            for (var key in inputElements) {
                data.append($("[name=" + inputElements[key].name + "]").data("name"), inputElements[key].value);
            }
            //File data
            var file_data = $(elem).find('input[data-name="receipt"]').get(0).files;
            for (var i = 0; i < file_data.length; i++) {
                data.append("receipt", file_data[i]);
            }
            $.ajax({
                url: saveProductUrl,
                method: "POST",
                data: data,
                processData: false,
                contentType: false,
                success: function (result) {
                    let elem = $('#productsAccordion .accordion-collapse[data-id=' + window.lastProduct + ']').parents('.accordion-item').get(0);
                    elem.setAttribute('data-saved', true);
                    insertNew();
                },
                error: function (xhr) {
                    let elem = $('#productsAccordion .accordion-collapse[data-id=' + window.lastProduct + ']').parents('.accordion-item').get(0);

                    let response = JSON.parse(xhr.responseText);
                    if (typeof response['errors'] !== "undefined") {
                        for (var key in response['errors']) {
                            let $field = $(elem).find('[data-name=' + key + ']:eq(0)');
                            if (!$field.hasClass('is-invalid')) {
                                $field.addClass('is-invalid');
                                $field.after(
                                    '<div id="validation' + key + 'Feedback" class="invalid-feedback">' +
                                    response['errors'][key] +
                                    '</div>'
                                );
                            }
                        }
                    }
                    if (typeof response['error'] !== "undefined") {
                        alertElica(response['message']);
                        window.location.href = homeUrl;
                    }

                    if ($("#productsAccordion .is-invalid").length) {
                        $("#productsAccordion .is-invalid").parents('.accordion-item').children('h4:not(.active)').children('button.accordion-button').click();
                        alertElica(translations.fixErrorsMsg);
                        $('html,body').animate({
                            scrollTop: $("#productsAccordion .is-invalid:first").parents('.accordion-item').offset().top
                        }, 'slow');
                        return false;
                    }
                }
            });
        });
    }
}

function insertNew() {
    let elem = $('#productsAccordion .accordion-collapse[data-id=' + window.lastProduct + ']').parents('.accordion-item').get(0);

    let newProduct = window.lastProduct + 1;

    // Destroy all select2 before cloning
    $(elem).find('.js-select').select2('destroy');

    let clone = elem.cloneNode(true);
    clone.id = `accordion-item-${newProduct}`;
    clone.dataset.saved = false;
    let cloneAccordionHeader = clone.querySelector('.accordion-header');
    cloneAccordionHeader.id = `accordion-header-${newProduct}`;
    let cloneAccordionTitleLabel = clone.querySelector('.accordion-item-title__label');
    cloneAccordionTitleLabel.textContent = cloneAccordionTitleLabel.dataset.defaultLabel;
    let cloneAccordionButton = clone.querySelector('.accordion-button');
    cloneAccordionButton.setAttribute('data-bs-target', `#accordion-collapse-${newProduct}`);
    cloneAccordionButton.setAttribute('aria-controls', `accordion-collapse-${newProduct}`);
    let cloneAccordionButtonTrigger = clone.querySelector('.accordion-button-trigger');
    cloneAccordionButtonTrigger.setAttribute('data-bs-target', `#accordion-collapse-${newProduct}`);
    cloneAccordionButtonTrigger.setAttribute('aria-controls', `accordion-collapse-${newProduct}`);
    let cloneAccordionCollapse = clone.querySelector('.accordion-collapse');
    cloneAccordionCollapse.id = `accordion-collapse-${newProduct}`;
    cloneAccordionCollapse.setAttribute('aria-labelledby', `accordion-header-${newProduct}`);
    cloneAccordionCollapse.setAttribute('data-select2-id', `accordion-collapse-${newProduct}`);
    cloneAccordionCollapse.dataset.id = newProduct;
    const cloneCategories = clone.querySelectorAll('.category');
    if (cloneCategories) {
        cloneCategories.forEach(cloneCategory => {
            const cloneCategoryInput = cloneCategory.querySelector('.category__input');
            const cloneCategoryLabel = cloneCategory.querySelector('.category__label');
            const cloneCategoryInputDataID = cloneCategoryInput.dataset.id;
            cloneCategoryInput.checked = false;
            cloneCategoryInput.id = `${cloneCategoryInputDataID}_${newProduct}`;
            cloneCategoryInput.name = `category_${newProduct}`;
            cloneCategoryLabel.setAttribute('for', cloneCategoryInput.id);
        });
    }
    const infoModalTriggerSerialNumber = clone.querySelector('[data-modal-source="fnr"]');
    infoModalTriggerSerialNumber.dataset.bsTarget = '#warningModal';
    const infoModalTrigger12NC = clone.querySelector('[data-modal-source="12nc"]');
    infoModalTrigger12NC.dataset.bsTarget = '#warningModal';
    const infoModalTriggerModel = clone.querySelector('[data-modal-source="model"]');
    infoModalTriggerModel.dataset.bsTarget = '#warningModal';
    const serialNumberInput = clone.querySelector('input[data-name="serial_number"]');
    serialNumberInput.name = `serial_number_${newProduct}`;
    serialNumberInput.value = "";
    const firstProductInfoWrap = clone.querySelector('.first-product-info-wrap');
    firstProductInfoWrap.classList.remove('d-none');
    const firstProductInfoInput = clone.querySelector('.first-product-info-wrap .form-check-input');
    const firstProductInfoLabel = clone.querySelector('.first-product-info-wrap .form-check-label');
    firstProductInfoInput.id = `first-product-info-toggler-${newProduct}`;
    firstProductInfoInput.name = `first_product_info_${newProduct}`;
    firstProductInfoInput.checked = true;
    firstProductInfoLabel.setAttribute('for', firstProductInfoInput.id);
    clone.querySelector('.input-reseller-wrap').classList.add('disabled');
    const resellerFieldsWrap = clone.querySelector('.reseller-fields-wrap');
    // resellerFieldsWrap.classList.add('d-none');
    const inputResellerInput = clone.querySelector('.input-reseller-wrap .form-control');
    const inputResellerLabel = clone.querySelector('.input-reseller-wrap .form-label');
    const inputReceiptWrap = clone.querySelector('.input-receipt-wrap');
    inputReceiptWrap.classList.add('d-none');
    inputResellerInput.id = `${inputResellerInput.dataset.id}-${newProduct}`;
    inputResellerInput.name = `${inputResellerInput.dataset.id}_${newProduct}`;
    inputResellerInput.setAttribute('disabled', 'disabled');
    inputResellerInput.removeAttribute('required');
    //inputResellerInput.value = "";
    inputResellerLabel.setAttribute('for', inputResellerInput.id);
    clone.querySelector('.input-purchase-date-wrap').classList.add('disabled');
    const inputPurchaseDateInput = clone.querySelector('.input-purchase-date-wrap .form-control');
    const inputPurchaseDateLabel = clone.querySelector('.input-purchase-date-wrap .form-label');
    inputPurchaseDateInput.id = `${inputPurchaseDateInput.dataset.id}-${newProduct}`;
    inputPurchaseDateInput.name = `${inputPurchaseDateInput.dataset.id}_${newProduct}`;
    inputPurchaseDateInput.setAttribute('disabled', 'disabled');
    inputPurchaseDateInput.removeAttribute('required');
    //inputPurchaseDateInput.value = "";
    inputPurchaseDateLabel.setAttribute('for', inputPurchaseDateInput.id);
    const inputReceiptInput = clone.querySelector('.input-receipt-wrap input');
    const inputReceiptLabel = clone.querySelector('.input-receipt-wrap label');
    const inputReceiptFileList = clone.querySelector('.input-receipt-wrap #file-chosen');
    inputReceiptInput.id = `${inputReceiptInput.dataset.id}-${newProduct}`;
    inputReceiptInput.name = `${inputReceiptInput.dataset.id}_${newProduct}`;
    inputReceiptInput.value = null;
    inputReceiptFileList.innerHtml = "";
    inputReceiptFileList.textContent = "";
    inputReceiptFileList.classList.remove('uploaded');
    inputReceiptLabel.setAttribute('for', inputReceiptInput.id);

    const input12NCInput = clone.querySelector('.js-select.form-control--code12nc');
    input12NCInput.id = `inputCode12NC_${newProduct}`;
    input12NCInput.name = `code_12nc_${newProduct}`;
    input12NCInput.value = "";
    input12NCInput.previousElementSibling.setAttribute('for', input12NCInput.id);

    const inputModelInput = clone.querySelector('.js-select.form-control--model');
    inputModelInput.id = `inputModel_${newProduct}`;
    inputModelInput.name = `model_${newProduct}`;
    inputModelInput.value = "";
    inputModelInput.previousElementSibling.setAttribute('for', inputModelInput.id);

    // Append clone accordion item
    elem.after(clone);

    ncSelect($(".js-select.form-control--code12nc"));
    modelSelect($(".js-select.form-control--model"));

    window.lastProduct++;

    // Collapse cloned accordion item
    let vecchio = new Collapse(elem.querySelector('.collapse'), {toggle: false});
    let nuovo = new Collapse(clone.querySelector('.collapse'), {toggle: false});
    vecchio.hide();
    nuovo.show();

    // Go to new accordion item anchor
    const newAccordionItemAnchor = '#' + clone.getAttribute('id');
    setTimeout(function() {
        $('html, body').animate({
            scrollTop: $(newAccordionItemAnchor).offset().top - 100
        },'slow');
    }, 400);
}
